// useWalletDeduction.ts
import { useEffect, useState } from 'react';
import { DiscountInfo } from './BuyChallenge';

export const useWalletDeduction = (
  useVirtualWallet: boolean,
  userWallet: number | undefined,
  calculateSubtotal: () => number,
  discountInfo: DiscountInfo | null,
) => {
  const [walletDeduction, setWalletDeduction] = useState(0);

  useEffect(() => {
    const subtotal = calculateSubtotal();
    const finalPrice = discountInfo ? discountInfo.finalPrice : subtotal;
    const deduction = useVirtualWallet
      ? Math.min(finalPrice, userWallet || 0)
      : 0;

    setWalletDeduction(deduction);
  }, [useVirtualWallet, userWallet, calculateSubtotal, discountInfo]);

  return walletDeduction;
};
